import React, { FC, ReactElement, useState, useEffect } from 'react';
import { CaretLeftOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';
import styles from './index.less';
import api from 'api/xqjy-service';

interface IPorps {
  title: string,
  catalogType: number,
  resType?: string,
  callback?: (catalog:number|string)=>void
}

const Catalog: FC<IPorps> = (props:IPorps): ReactElement => {

  const { title, catalogType, callback, resType } = props
  const [list, setList] = useState<any>([])
  const [currentId, setCurrentId] = useState<any>()

  useEffect(()=>{
    if(catalogType === -1){
      api.kinder.jobTitleList().then(result=>{
        setList(result.data)
      })
    }else{
      api.base.catalogList({type: catalogType}).then(result=>{
        const cList = result.data
        if(resType){
          let arr:any = []
          // 模型只显示二级目录
          if(resType === '0'){
            cList.forEach((item:any)=>{
              if(item.name === '3D模型'){
                arr = item.children
              }
            })
          }else{
            cList.forEach((item:any)=>{
              if(item.name !== '3D模型'){
                arr.push(item)
              }
            })
            
          }
          setList(arr)
        }else{
          setList(cList)
        }
      })
    }
  }, [catalogType, resType])

  const itemClick = (id:any)=>{
    return ()=>{
      if(id === currentId)
        id = null
      setCurrentId(id)
      if(callback){
        callback(id)
      }
    }
  }

  const openClose = (item:any)=>{
    return ()=>{
      item.open = item.open ? false : true
      let arr = []
      for(let i in list){
        if(list[i].catalogId === item.catalogId){
          arr.push(item)
        }else{
          arr.push(list[i])
        }
      }
      setList(arr)
    }
  }

  return (
    <div className={styles.catalog}>
      <div className={styles.title}>
        <span>{title}</span>
      </div>
      {
        catalogType === -1 &&
        <div className={styles.list}>
          {
            list.map((item:any)=>{
              return <div className={`${styles.item} ${currentId===item ? styles.current: ''}`} key={item}>
                <div className={styles.name} onClick={itemClick(item)}>{item}</div>
                <div className={styles.flag}>
                  { currentId===item && <CaretLeftOutlined /> }
                </div>
              </div>
            })
          }
        </div>
      }
      {
        catalogType>0 && 
        <div className={styles.tree}>
          {
            list.map((item:any)=>{
              return (
                <div className={styles.node} key={item.catalogId}>
                  <div className={`${styles.name} ${currentId===item.catalogId ? styles.current: ''}`}>
                    {
                      item.children && item.children.length>0 &&
                      <span className={styles.icon} onClick={openClose(item)}>
                        {!item.open && <RightOutlined />}
                        {item.open && <DownOutlined />}
                      </span>
                    }
                    <span onClick={itemClick(item.catalogId)}>{item.name}</span>
                  </div>
                  {
                    item.open && item.children &&
                    <div className={styles.children}>
                      {
                        item.children.map((chItem:any)=>{
                          return <div className={styles.chNode} key={chItem.catalogId}>
                              <span className={`${currentId===chItem.catalogId ? styles.current: ''}`} onClick={itemClick(chItem.catalogId)}>{chItem.name}</span>
                            </div>
                        })
                      }
                    </div>
                  }
                </div>
              )
            })
          }
        </div>
      }
    </div>
  )
}

export default Catalog